import styles from './CadastroResponsavel.module.css';
import inputStyles from '../../../shared/form/Input.module.css';
import Input from '../../../shared/form/Input';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function CadastroResponsavel() {
    const API_URL = process.env.REACT_APP_API_URL;
    const navigate = useNavigate();

    const [step, setStep] = useState(1);
    const [escolas, setEscolas] = useState([]);
    const [clientes, setClientes] = useState([]);
    const [escolaSelecionada, setEscolaSelecionada] = useState('');
    const [clienteSelecionado, setClienteSelecionado] = useState('');
    const [formData, setFormData] = useState({
        nome: "",
        email: "",
        senha: "",
        confirme_senha: "",
        nome_aluno: "",
        escola: ""
    });

    useEffect(() => {
        // Buscar escolas/universidades
        fetch(`${API_URL}/universidades-escolas-publico`)
            .then(res => res.json())
            .then(data => setEscolas(Array.isArray(data) ? data : []))
            .catch(err => console.error("Erro ao buscar escolas:", err));

        // Buscar clientes
        fetch(`${API_URL}/clientes-publico`)
            .then(res => res.json())
            .then(data => setClientes(Array.isArray(data) ? data : []))
            .catch(err => console.error("Erro ao buscar clientes:", err));
    }, [API_URL]);


    function stepResponsavel({setStep}) {
        return(
             <main className={styles.secaoprincipal}>
                <header className={styles.cabecalho_page}>
                    <h2>Bem-vindo ao UniEat!</h2>
                    <p>Crie sua conta gratuita e cuide da alimentação do seu filho com praticidade e segurança.</p>
                </header>

                <form className={styles.formulario}> 

                    <Input
                        type="text"
                        text="Nome Completo"
                        name="nome"
                        placeholder="Digite seu nome completo"
                        value={formData.nome}
                        handleOnChange={(e) => 
                            setFormData({...formData, nome: e.target.value})
                        }
                    />

                    <Input
                        type="email"
                        text="E-mail"
                        name="email"
                        placeholder="Digite seu e-mail"
                        value={formData.email}
                        handleOnChange={(e) => 
                            setFormData({...formData, email: e.target.value})
                        }
                    />

                    <Input
                        type="password"
                        text="Senha"
                        name="senha"
                        placeholder="Digite sua senha"
                        value={formData.senha}
                        handleOnChange={(e) => 
                            setFormData({...formData, senha: e.target.value})
                        }
                    />

                    <Input
                        type="password"
                        text="Confirme a Senha"
                        name="confirme_senha"
                        placeholder="Confirme sua senha"
                        value={formData.confirme_senha}
                        handleOnChange={(e) => 
                            setFormData({...formData, confirme_senha: e.target.value})
                        }
                    />

                    <button type="button" onClick={() => setStep(step + 1)}>
                    Próximo
                    </button>

 
                </form>

            </main>
        )


    }
function stepAluno({setStep}) {
        return(
             <main className={styles.secaoprincipal}>
                <header className={styles.cabecalho_page}>
                    <h2>Bem-vindo ao UniEat!</h2>
                    <p>Crie sua conta gratuita e cuide da alimentação do seu filho com praticidade e segurança.</p>
                </header>

                <form className={styles.formulario}>

                    <div className={inputStyles.itensform}>
                        <label>Selecione a Escola/Universidade</label>
                        <select value={escolaSelecionada} onChange={(e) => setEscolaSelecionada(e.target.value)}>
                            <option value="">Selecione a Escola</option>
                            {escolas.map(escola => (
                                <option key={escola.id_universidade} value={escola.id_universidade}>{escola.nome}</option>
                            ))}
                        </select>
                    </div>

                    <div className={inputStyles.itensform}>
                        <label>Selecione o Aluno</label>
                        <select value={clienteSelecionado} onChange={(e) => setClienteSelecionado(e.target.value)}>
                            <option value="">Selecione o Aluno</option>
                            {clientes.map(cliente => (
                                <option key={cliente.id_cliente} value={cliente.id_cliente}>{cliente.nome}</option>
                            ))}
                        </select>
                    </div>

                  

                <button onClick={() => setStep(1)}>
                        Voltar
                    </button>


                    <button  type="button"
                        onClick={() => criarConta()}>
                        Criar Conta
                    </button>
 
                </form>

            </main>
        )


    }

    const criarConta = async (e) => {
        const payload = {
            nome_responsavel: formData.nome,
            email_responsavel: formData.email,
            senha: formData.senha,
            clientes: [clienteSelecionado],
            id_escola: escolaSelecionada
        };
        console.log("Payload para criação de conta:", payload);

        try {
            const response  = await fetch(`${API_URL}/responsaveis`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        })
        const data = await response.json();

        const salvarDados = (data) => {
            localStorage.setItem("id_responsavel", data.id_responsavel)
        }

        if(!response.ok){
            console.log("Erro ao cadastrar o responsavel")
        }else{
            salvarDados(data)
            navigate('/homeresponsavel')
        }
        } catch (error) {
            console.error("Erro: ", error)
        }


     


    }
    return(
            <div>
                {step === 1 && stepResponsavel({setStep})}
                {step === 2 && stepAluno({setStep})}
            </div>
    )
}

export default CadastroResponsavel;